
import { IconBadge, IconCalendar, openModal } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'

import translations from './ReassuranceButtons.translations'

export default {
  components: {
    IconBadge,
    IconCalendar,
  },
  props: {},
  computed: {
    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
      experiments: 'experiments/getExperiments',
    }),
    translations: () => translations,

    returnTranslation() {
      if (
        this.experiments.ppContentReassuranceInfoPosition ===
        'reassuranceInfoAbove'
      ) {
        return translations.changeMind
      }

      return translations.freeReturn
    },
  },
  methods: {
    deploySatisfactionModal() {
      openModal(MODAL_NAMES.REASSURANCE.SATISFACTION)
    },
  },
}
